<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3>{{monthlyLan.indexText}}</h3>
      </div>
      <div class="panel" element-loading-spinner="el-icon-loading" v-loading="loading">
        <mtable
          :back="back"
          :downLoadTran="downLoadTran"
          :jsonExcelAjax="jsonExcelAjax"
          :link="link"
          :multiLanguage="monthlyLan"
          :name="name"
          :page="page"
          :region="curArea"
          :selPage="selPage"
          :thData="thData"
          :trData="trData"
          @tableChange="tableAjax"
          v-if="trData"
        >
          <div class="monthlyHandle" slot="handle">
            <div class="searchDiv">
              <span>{{monthlyLan.start_time}}</span>
              <el-date-picker
                :placeholder="monthlyLan.selectTimeText"
                style="width: 200px"
                v-model="beginTime"
              ></el-date-picker>
            </div>
            <div class="searchDiv">
              <span>{{monthlyLan.end_time}}</span>
              <el-date-picker
                :placeholder="monthlyLan.selectTimeText"
                style="width: 200px"
                v-model="endTime"
              ></el-date-picker>
            </div>
            <div class="btnDiv">
              <el-button @click="searchData" type="primary">{{monthlyLan.search}}</el-button>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from '../../comm/mytable'
import { formatDate, getTimeDiff, updateTimeByUtc } from 'common/js/util'
import { URL_IBMONTHLYINDEX } from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
  name: 'monthlyIBResult',
  mixins: [require('common/mixin/base.js').base({ monthlyLan: 'monthlyIBResult' })],
  props: ['curArea'],
  data() {
    return {
      trData: [],
      url: '',
      beginTime: '',
      endTime: '',
      timeDiff: 0,
      loading: true,
      changeTime: false,
      link: {
        key: ['IBCommissionResult'],
        path: 'monthlyIBCommisionResult'
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    }
  },
  mounted() {
    this.timeDiff = getTimeDiff()
    if (sessionStorage.getItem('back')) {
      let backObj = JSON.parse(sessionStorage.getItem('back'))
      if (backObj.path === 'monthlyIBResult') {
        this.beginTime = backObj.beginTime
        this.endTime = backObj.endTime
        this.page.active = backObj.pageNum + 1
        this.selPage.limit = backObj.pageSize
      }
      this.tableAjax()
      sessionStorage.removeItem('back')
    } else {
      this.tableAjax()
    }
  },
  methods: {
    searchData() {
      this.loading = true
      this.page.active = 1
      this.tableAjax()
    },
    tableAjax() {
      this.changeTime = true;
      this.url = api.getUrl20(this.curArea,URL_IBMONTHLYINDEX)
      let obj = {
        params: {
          type: 'IB',
          iscpa: false,
          beginTime: formatDate(this.beginTime),
          endTime: formatDate(this.endTime),
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      }
      this.$http.get(this.url, obj).then(res => {
        this.trData = res.data.data.rows
        this.page.pageLeng = res.data.data.count
        this.setOfficeState()
        this.loading = false
      })
    },
    setOfficeState() {
      let list = this.monthlyLan.statusList
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach((item, index) => {
          let temp = this.trData[index]
          temp.IBCommissionResult = this.monthlyLan.monthlyTh[1].name
          temp.status = temp.STATUS || temp.STATUS == 0 ? list[temp.STATUS] : ''
          if (this.changeTime) temp.LAST_UPDATE = updateTimeByUtc(this.timeDiff, temp.LAST_UPDATE)
        })
      }
    }
  },
  computed: {
    back() {
      return JSON.stringify({
        path: 'monthlyIBResult',
        beginTime: this.beginTime,
        endTime: this.endTime,
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit
      })
    },
    name() {
      return this.monthlyLan.indexText
    },
    downLoadTran() {
      return { STATUS: this.monthlyLan.statusList }
    },
    thData() {
      return this.monthlyLan.monthlyTh
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'rows'],
        ajaxPar: {
          type: 'IB',
          iscpa: false,
          pageSize: this.page.pageLeng,
          pageNum: 0,
          beginTime: formatDate(this.beginTime),
          endTime: formatDate(this.endTime)
        }
      }
    }
  },
  watch: {
    monthlyLan() {
      this.changeTime = false
      this.setOfficeState()
    },
    curArea() {
      ;(this.beginTime = ''), (this.endTime = ''), (this.page.active = 1)
      this.loading = true
      this.tableAjax()
    }
  },
  components: {
    mtable
  }
}
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
}
.monthlyHandle {
  float: left;
  .searchDiv {
    float: left;
    margin-right: 20px;
  }
  .btnDiv {
    float: left;
    margin-right: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// monthlyIBResult.vue?4478e74a